export default {
    props: {
        icon: String,
        iconset: { type: String, default: 'md' }
    }
};
